import { useEffect } from 'react';
import { usageTracker } from '../utils/usageTracker';
import usePageContentObjectType from './usePageContentObjectType';
export const useTrackPageView = subscreen => {
  const pageType = usePageContentObjectType();
  useEffect(() => {
    usageTracker.track('pageView', {
      screen: 'detail',
      subscreen,
      pageType
    });
  }, [pageType, subscreen]);
};